module.exports = __webpack_public_path__ + "img/aa83b5b.jpg";